import { defineStore } from 'pinia';
import APIClient from '~/api/apiClient';
import { PromotionsResponse } from '~/api/apiClient';
import { priceStringToCents } from '~/utils/prices.ts';
import { CMSClient, IGroupedCMSItems, ItemType } from '~/api/cmsClient';
import { CommonData } from '~/types/index.ts';
 
const apiClient = APIClient.getInstance();
const cmsClient = CMSClient.getInstance();

interface DataState {
  products: {
    plugin: [],
    samplepack: [],
    bundle: [],
    other: []
  },
  commonData: CommonData | null;
  promotions: PromotionsResponse | null;
}

function mapDataBasedOnType(phpData: any, cmsItems: IGroupedCMSItems, type: ItemType) {
  if (!cmsItems[type]) {
    console.log(`Warning: No data found for type: ${type} in CMS items.`);
    return phpData;
  }
  
  const cmsData = cmsItems[type].find(item => item.name === phpData.name);
  if (!cmsData) {
    console.log(`Warning: No matching ${type} found in CMS for name: ${phpData.name}`);
    return null; 
  }
  console.log("adf phpData:", phpData);
  return {
    ...phpData,
    ...cmsData,
    total_discount: phpData.price?.total_discount ? Math.round(phpData.price.total_discount.amount_percentage) : null,
    price: mapPriceToCents(phpData.price?.full_price || null),
    discounted_price: mapPriceToCents(phpData.price?.total_discount.new_price || null),
  };
}

function mapPriceToCents(price) {
  if (!price) {
    console.log("Free product detected. Price is:", price);
    return {
      EUR: 0,
      JPY: 0,
      USD: 0,
    };
  }
  
  console.log("adf mapPriceToCents:", price);
  return {
    EUR: priceStringToCents(price.EUR),
    JPY: priceStringToCents(price.JPY),
    USD: priceStringToCents(price.USD),
  };
}


export const useDataStore = defineStore('dataStore', {
  state: (): DataState => ({
    products: {
      plugin: [],
      samplepack: [],
      bundle: [],
      other: []
    },
    commonData: null,
    promotions: null,
  }),
  actions: {
  
    async fetchProductData(forceUpdate: boolean = false) {
      if (this.products.plugin.length > 0 && this.products.samplepack.length > 0 && !forceUpdate) {
        return;
      }
    
      try {
        const cmsResponse = await cmsClient.fetchItems();
        console.log("cmsResponse:", cmsResponse);
        const newResponse = await apiClient.getAllProductsNew();
        console.log("newResponse:", newResponse);
        if(newResponse === null || cmsResponse === null)
        {
          return;
        }
    
        if(newResponse !== null && newResponse.valid && newResponse.result && newResponse.result.result) {
          const sortedProducts = {
            plugin: [],
            samplepack: [],
            bundle: [],
            other: []
          };
    
          // Sort products based on type
          for (const product of newResponse.result.result) {
            if (sortedProducts[product.type]) {
              sortedProducts[product.type].push(product);
            } else {
              console.warn(`Unexpected product type: ${product.type}`);
            }
          }
    
          // Map and merge data
          for (const type of ['plugin', 'samplepack', 'bundle', 'other'] as const) {
            this.products[type] = sortedProducts[type]
              .map(data => mapDataBasedOnType(data, cmsResponse, type))
              .filter(Boolean); // Filter out any null values
          }
          console.log("dataStore.products:", this.products);
    
        } else {
          console.error("Unable to fetch data from faBackend.");
        }
    
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },    

    async fetchCommonData() {
      this.commonData = await cmsClient.fetchCommonData();
    },

    isFreeProduct(productName: string): boolean {
      const pluginProduct = this.products.plugin.find(p => p.name === productName);

      if(pluginProduct && !pluginProduct.price) {
        console.log("Free product detected:", pluginProduct);
        return true;
      }

      if (pluginProduct && pluginProduct.price.USD === 0) {
        return true;
      }

      const samplepackProduct = this.products.samplepack.find(sp => sp.name === productName);
      if (samplepackProduct && samplepackProduct.price.USD === 0) {
        return true;
      }

      return false;
    },

    
    async fetchPromotions() {
      if(this.promotions === null) {
      this.promotions = await apiClient.getPromotions();
      }
    },

    getProductByName(productName : string)  {
      return [
        ...this.products.plugin, 
        ...this.products.samplepack,
        ...this.products.bundle // Assuming bundle is an array similar to plugin and samplepack
      ].find(product => product.name === productName);
    },


    init() {
      console.log("Initializing dataStore");
      this.fetchProductData();
    },
    getProductSlug(productName: string): string {
      // Search in plugins
      const pluginProduct = this.products.plugin.find(p => p.name === productName);
      if (pluginProduct) {
        return `/products/plugins/${pluginProduct.slug}`;
      }

      // Search in samplepacks
      const samplepackProduct = this.products.samplepack.find(sp => sp.name === productName);
      if (samplepackProduct) {
        return `/products/guitar-cabinet-impulse-responses/${samplepackProduct.slug}`;
      }

      // Add similar search for other product types if necessary

      // Return a default slug or null if product is not found
      return `/products/${productName}`; // Modify this line as per your requirements
    }
  },
  
});
